import React, { FC } from "react";
import { Slider as MuiSlider, SliderProps } from "@mui/material";

const Slider: FC<SliderProps> = (props) => <MuiSlider {...props} />;

export default Slider;
